<template>
    <v-content style="padding:0">
        <v-container>
            <v-layout row>
            <v-flex xs12>
                <p :class="config.campagnaWeb=='S' ? 'primary--text display-3 font-weight-bold text-md-center sellaBold' : 'primary--text display-3 font-weight-bold text-md-center sellaBold'" >Dicono di noi</p>
                        <v-layout  align-center justify-space-between row >
                            <v-flex md12 xs12>
                                <v-img v-on="on" :src="'https://www.sellapersonalcredit.it/images/trustpilot_oriz_1280.gif'" style="cursor:pointer" aspect-ratio=3.77></v-img>
                            </v-flex>
                        </v-layout>
            </v-flex>
            </v-layout>
        </v-container>
    </v-content>

</template>

<script>
    export default {
        props: {
            config: {
            }
        }
    };
</script>


<style scoped>
    .sellaStencil {
        font-family: 'Sella Stencil' !important;
    }
    .sella {
        font-family: 'Sella';
    }
</style>
